export default Object.freeze({
  list: [],
  selectedClient: null,
});
